// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Tk-z","sponsoredTooltipWrapper":"Uk-z","sponsoredTooltip":"Vk-z","newCard":"Wk-z"};